/*
 * @Author: Roman
 * @Date: 2023-02-22 14:50:51
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2023-06-08 16:52:54
 * @FilePath: \qpmn-site\language\en\system.js
 * @Description: 
 */
let missParameter = "Parameters are missing,Please contact the administrator!",
    parameterError = "Parameter error,Please contact the administrator! ",
    templateError = "Template error,Please contact the administrator!",
    statusError = "Status error,Please contact the administrator!",
    configError = "config error,Please contact the administrator!",
    requestError = "Request error,Please refresh and try again!",
    parseError = "the file is parsed error, please check  the file is normal !",
    uploadError = " file upload fail,please upload again!",
    unrealized = "Processing of this class is not implemented,Please contact the administrator!",
    programError = "program error,please contact the administrator!",
    attributeError = "Product property verification failed. Please view the current product property.",
    tokenExpired = "The current token has expired. Please log in again.",
    networkError = "The network is abnormal. Please try again later!"



exports.language = {
    /************************************ 02:Base ************************************/
    // 请求地址不存在404
    A102B001: "The service address being published or configured by the system does not exist, please contact the administrator.",
    // 调用采集错误时,未传入errorCode
    A102B002: "No incoming error code",
    // 网络连接失败标题
    A102B003: "Connection Failed",
    // 网络连接失败提示文本
    A102B004: "Oops! Connection failed when you were trying to pass data to the server. Please check your network connection. Alternatively, you can refresh this page and try again. If the problem still exists, please contact our technical support",
    // 网络连接超时标题
    A102B005: "Network connection timeout",
    // 网络连接超时文本
    A102B006: "There was a network fluctuation,which caused the request to timeout. Please try again later.",
    // 权限不足提示需登录的标题
    A102B007: "Go to login?",
    // 权限不足提示需登录的文本描述
    A102B008: "You are not currently logged in or the permission is invalid",
    // 需登录提示
    A102B009: "The current page needs to be logged in to access it.",
    // 删除前提示标题
    A102B0010: "You want delete?",
    A102B0011: "Question",
    A102B0012: "Network connection interrupted",
    A102B0013: "Please check your network and try again.",
    // 选中项将会被删除
    A102B0014: "Selected Item vill be deleted.",
    A102B0015: "Deleted Successfully",





    /***** N:网络错误 *******/
    A103N000: requestError,
    A103N001: requestError,
    A103N002: parameterError,
    // token过期
    A103N003: tokenExpired,

    /***** P:参数错误- *******/
    A103P001: parameterError,


    /************************************ 04:Builder ************************************/
    /************************************ 05:购物车 ************************************/


    /************************************ 06:结算 ************************************/



    /************************************ 07:User模块 ************************************/
    /***** B:业务错误 *******/
    // 获取默认收货地址失败
    A107B001: "Default receiving address is missing",
    // 权限相关:权限不足
    A107B002: "Missing Authentication",
    A107B003: "You don't have authentication or it is expired, click OK to login again or click Cancel to visit this page as an anonymous user.",
    A107B004: "You don't have authentication or it is expired, click OK to login and go on.",
    A107B005: "The current operation needs to log in to use, whether to log in?",



    /************************************ 08: Store Product ************************************/
    // 添加网店产品确实EditType参数
    A108B001: "Lack of program parameters",
    // 返回的店铺产品Clazz错误
    A108B002: "The current store product data is abnormal,please contact the administrator",
    // ExpressionPricingSetting 网店产品暂时不支持当前价格配置
    A108B003: "Unsupported price configuration",
    A108B004: "The current store product type is not currently supported",
    /************************************ 16: ************************************/
    A116P004: 'Missing store information.',
    A116P005: 'Thank you for your message, we will contact you with your phone or email a little bit later.',


    /************************************ 失踪的身份验证--提示用户登录 ************************************/
    MISSING_AUTHENTICATION_TITLE:"Missing Authentication",
    MISSING_AUTHENTICATION_DES:"You don't have authentication or it is expired, click OK to login and go on.",
    MISSING_AUTHENTICATION_CANCEL_BTN:"CANCEL",
    MISSING_AUTHENTICATION_OK_BTN:"OK"

};